import React, { Component, Fragment } from 'react';
import { Alert, Button, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, withApollo } from 'react-apollo';

export const archiveHSCodeMutation = gql`
  mutation archiveHScode($id: Int!) {
    archiveHSCode(id: $id) {
      id
    }
  }
`;

export class HSCodeArchive extends Component {
  state = {
    isOpen: false,
    submitting: false,
    error: null
  };

  setError = error => {
    this.setState({ error });
  };

  setSubmitting = submitting => {
    this.setState({ submitting });
  };

  onToggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  renderNopeModalInner = () => {
    // You can't delete an hs code if it has products
    const { products } = this.props.code;

    return (
      <Fragment>
        <ModalHeader toggle={this.onToggle}>Cannot archive</ModalHeader>
        <ModalBody>
          <p className="mb3">
            You can't archive this code as some products have it as their HS Code. You'll need to remove it from these
            products before you can archive:
          </p>
          <ul className="mb0">
            {products.map(product => (
              <li key={product.id}>{product.name}</li>
            ))}
          </ul>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.onToggle}>
            Ok
          </Button>{' '}
        </ModalFooter>
      </Fragment>
    );
  };

  renderConfirmationModalInner = () => {
    const { client, code, history } = this.props;
    const { name } = code;
    const { submitting, error } = this.state;
    return (
      <Mutation mutation={archiveHSCodeMutation}>
        {archiveHSCode => (
          <Fragment>
            <ModalHeader toggle={this.onToggle}>Are you sure?</ModalHeader>
            <ModalBody>
              {error && <Alert color="danger">{error}</Alert>}
              Are you sure you want to archive the HS Code <em>{name}</em>?
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.onToggle}>
                Cancel
              </Button>{' '}
              <Button
                data-qa="hsCode-archive-ok"
                disabled={submitting}
                color="primary"
                onClick={async () => {
                  try {
                    this.setSubmitting(true);
                    await archiveHSCode({
                      variables: {
                        id: code.id
                      }
                    });
                    // Clear cache
                    client.resetStore();
                    history.push(`/settings/hscodes?archived=${name}`);
                  } catch (err) {
                    this.setSubmitting(false);
                    this.setError('An unknown error occured');
                  }
                }}
              >
                Archive
              </Button>
            </ModalFooter>
          </Fragment>
        )}
      </Mutation>
    );
  };

  render() {
    const { className, code } = this.props;

    if (!code) {
      // In some cases where hs code comes though asyncronously, there is a chance that the hs code
      // does not exist yet. If that is the case, don't render anything
      return null;
    }

    return (
      <Fragment>
        <Button data-qa="hscode-archive" className={className} color="danger" outline onClick={this.onToggle}>
          Archive
        </Button>
        <Modal isOpen={this.state.isOpen} toggle={this.onToggle}>
          {code.products.length ? this.renderNopeModalInner() : this.renderConfirmationModalInner()}
        </Modal>
      </Fragment>
    );
  }
}

export default withRouter(withApollo(HSCodeArchive));



// WEBPACK FOOTER //
// ./src/containers/hsCodeArchive/hsCodeArchive.jsx